import { render } from "./gzhRecommended.vue?vue&type=template&id=ddae7dd4"
import script from "./gzhRecommended.vue?vue&type=script&lang=js"
export * from "./gzhRecommended.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__